import { useTranslation } from "react-i18next"
import { Link } from "react-router-dom"

import { useDocumentTitle } from "@/lib/useDocumentTitle"

export function NotFoundPage() {
  const { t } = useTranslation()
  useDocumentTitle(t("common.notFound"))
  return (
    <div className="max-w-(--container-narrow) mx-auto px-6 band-state text-center">
      <h1 className="text-h1 font-semibold text-ink mb-4">{t("common.notFound")}</h1>
      <Link to="/" className="text-ink underline decoration-rule underline-offset-4 hover:decoration-ink">
        {t("nav.catalog")} →
      </Link>
    </div>
  )
}
